import { Parser } from '~/api';
import { User } from '~/api/models';
import RequestService from './request';

interface CreateUserRequest {
    email: string;
    name_first: string;
    name_last: string;
    external_id: string;
    password: string;
    root_admin: boolean;
    support_op: boolean;
    support_op_bypass: string;
}

type UpdateUserRequest = CreateUserRequest & {
    ignore_connection_error: boolean;
};

interface DeleteUserRequest {
    id: number;
}

class UsersService {
    getAll(req: PaginatableRequest, extraData: PaginatableRequest = {}): Promise<User[]> {
        return RequestService.get('/users', {
            ...req,
            ...extraData,
            include: ['serversCount', 'subuserOfCount'],
            filter: {
                ...(req.filter ?? {}),
                ...(extraData.filter ?? {}),
            },
        }).then(Parser.parse);
    }

    get(): Promise<User> {
        return RequestService.get('/users/:user').then(Parser.parse);
    }

    create(data: CreateUserRequest): Promise<User> {
        return RequestService.post('/users', data).then(Parser.parse);
    }

    update(data: UpdateUserRequest): Promise<User> {
        return RequestService.put('/users/:user', data).then(Parser.parse).then(RequestService.updateModelBinding);
    }

    disable2FA(): Promise<User> {
        return RequestService.post('/users/:user/disable-2fa').then(Parser.parse).then(RequestService.updateModelBinding);
    }

    delete(data: DeleteUserRequest): Promise<void> {
        return RequestService.delete(`/users/${data.id}`);
    }
}

export default new UsersService();
